import * as React from "react";
import {getContainer} from "../../ioc/IOCSetup";
import {AdminNote} from "../../http/protocol";
import {formatDate} from "../../util/date";
import { ConfirmModal } from "../../util/ConfirmModal";

interface Props {
    note: AdminNote;
    show? : boolean;
    deleteNote:(id: number)=>void;
}
interface State {
    pinned?: boolean;
    showConfirmModal?:boolean;
}
export class AdminNoteComp extends React.Component<Props,State> {
    constructor(props: Props) {
        super(props);
        this.state = {
            pinned: this.props.note.pinned
        };
    }
    handlePin(note: AdminNote) {
        let n = note;
        n.pinned = !n.pinned;
        getContainer().getAdminNotesService().save(n).then( res => {
            this.setState({pinned: n.pinned});
        });
    }

    // this.props.deleteNote(this.props.note.id!)

    render() {
        if (!this.props.show) {
            return <span/>
        }
        return (
            <><li className="clearfix">
                <div className="conversation-text">
                    <div className="ctext-wrap">
                        <span onClick={() => this.handlePin(this.props.note)} className={"badge badge-pill float-right " + (this.state.pinned ? "badge-danger" : "badge-light")}>
                            <i className="dripicons-pin"></i>
                        </span>
                        <span onClick={() => this.setState({ showConfirmModal: true })} className={"badge badge-pill float-right " + (this.state.pinned ? "badge-danger" : "badge-light")}>
                            <i className="dripicons-cross"></i>
                        </span>
                        <span>{this.props.note.created && formatDate(Number(this.props.note.created.toString().split(".").join("").substring(0, 13)))}</span>
                        <i>{this.props.note.authorName}</i>
                        <p>
                            {this.props.note.comment}
                        </p>
                    </div>
                </div>
            </li>
            <div>
                {this.state.showConfirmModal===true && (
                    <ConfirmModal
                    show={this.state.showConfirmModal}
                    heading="Confirm Delete Note"
                    description={`You are about to Delete note id `.concat(this.props.note.id!.toString())}
                    okLabel="Delete"
                    onOk={
                        ()=>this.props.deleteNote(this.props.note.id!)
                    }
                    onCancel={()=>{this.setState({showConfirmModal:false})}}
                    hideCancelButton={true}
                    />
                )}
            </div></>
        );
    }
}
